import { Pipe, PipeTransform } from "@angular/core";
import { IService, PriceType } from '@core/interfaces';

export interface ServicesPriceSummary {
  amountText: string;
  isExact: boolean;
  hasUncalculablePrices: boolean;
}

@Pipe({
  name: 'TotalPriceFromServices'
})
export class TotalPriceFromServicesPipe implements PipeTransform {
  transform(value: IService[] | null | undefined): ServicesPriceSummary | null {
    if (!value?.length) {
      return null;
    }

    let total = 0;
    let currencySymbol = '';
    let hasFixedAmount = false;
    let hasUncalculablePrices = false;

    value.forEach(service => {
      const price = service?.price;
      const rawAmount = price?.fixedAmount;
      const amount = Number(rawAmount);

      if (this.isFreePrice(price?.priceType)) {
        return;
      }

      if (
        rawAmount !== null
        && rawAmount !== undefined
        && this.isFixedPrice(price?.priceType)
        && Number.isFinite(amount)
      ) {
        total += amount;
        hasFixedAmount = true;
        currencySymbol ||= price?.currencySymbolNative || price?.currencySymbol || '';
        return;
      }

      hasUncalculablePrices = true;
    });

    if (!hasFixedAmount) {
      return null;
    }

    return {
      amountText: `${currencySymbol}${total}${hasUncalculablePrices ? '+' : ''}`,
      isExact: !hasUncalculablePrices,
      hasUncalculablePrices
    };
  }

  private isFixedPrice(priceType: PriceType | number | string | null | undefined): boolean {
    return priceType === PriceType.FixedPrice
      || priceType === 1
      || priceType === '1';
  }

  private isFreePrice(priceType: PriceType | number | string | null | undefined): boolean {
    return priceType === PriceType.Free
      || priceType === 4
      || priceType === '4';
  }
}
